webpackJsonp([25211195520765],{

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TechnologiesPageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _graphql = __webpack_require__(8);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _gatsbyLink = __webpack_require__(30);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(9);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TechnologiesPage = function TechnologiesPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Technologies Offered | ' + data.site.siteMetadata.title }),
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Technologies page'
	    ),
	    data.allFile && data.allFile.edges.map(function (_ref2) {
	      var node = _ref2.node;
	      return _react2.default.createElement(
	        _gatsbyLink2.default,
	        { key: node.name, to: node.relativeDirectory + '/' + node.name },
	        node.name
	      );
	    })
	  );
	};
	
	exports.default = TechnologiesPage;
	var TechnologiesPageQuery = exports.TechnologiesPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-technologies-index-jsx-873dad0441ecbe1d9e50.js